import styled from 'styled-components';
import { commonInputStyles } from 'components/common/commonInputStyles';
import { Input } from 'antd';

export const InputStyled = styled(Input)<any>`
  ${commonInputStyles}
`;
